export const issueReasonType = Object.freeze({
    NEW_EMPLOYEE: '2658836517000',
    LOST: '2658836521000'
});